import { getOrderItems, getOrderProductRating } from 'analytics/eventDefinitions'

export interface OptimizelyEvent {
  type: 'event'
  eventName: string
  tags?: any
}

export enum SearchResultType {
  All = 'all',
  Flash = 'flash',
  LPC = 'lpc',
  Bedbank = 'lpp',
  Hidden = 'hidden'
}

export function auPurchaseClickEvent(order: App.Order): OptimizelyEvent {
  const orderItems = getOrderItems(order)
  const orderProductRating = getOrderProductRating(orderItems, order.total)

  return {
    type: 'event',
    eventName: 'transaction-au',
    tags: {
      revenue: order.total * 100,
      value: orderProductRating,
    },
  }
}

export function searchResultCount(type: SearchResultType, count: number): OptimizelyEvent {
  return {
    type: 'event',
    eventName: `search-result-${type}-count`,
    tags: {
      value: count,
    },
  }
}

export function searchClickPosition(pos: number): OptimizelyEvent {
  return {
    type: 'event',
    eventName: 'search-click-position',
    tags: {
      value: pos,
    },
  }
}
